import { Popover } from 'antd';
import React from 'react';

export const LCPopOver = props => <Popover {...props} />;
